export function startOfDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate())
}

export function addDays(date, days) {
  const copy = new Date(date)
  copy.setDate(copy.getDate() + days)
  return copy
}

export function addMonths(date, count) {
  const day = date.getDate()
  const next = new Date(date.getFullYear(), date.getMonth() + count, 1)
  const last = new Date(next.getFullYear(), next.getMonth() + 1, 0).getDate()
  next.setDate(Math.min(day, last))
  return next
}

export function parseIso(iso) {
  const [year, month, day] = iso.split('-').map(Number)
  return new Date(year, month - 1, day)
}

export function formatIso(date) {
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${date.getFullYear()}-${month}-${day}`
}

export function weekStartsOnSunday(locale) {
  try {
    const info =
      typeof new Intl.Locale(locale).getWeekInfo === 'function'
        ? new Intl.Locale(locale).getWeekInfo()
        : new Intl.Locale(locale).weekInfo
    return info?.firstDay === 7
  } catch {
    return false
  }
}

export function startOfWeek(date, locale) {
  const offset = weekStartsOnSunday(locale) ? date.getDay() : (date.getDay() + 6) % 7
  return addDays(startOfDay(date), -offset)
}

function slotDates(slots) {
  return (slots || []).map((slot) => slot?.scheduledLocal?.date).filter(Boolean)
}

export function earliestSlotDate(slots) {
  const dates = slotDates(slots).sort()
  return dates[0] ? parseIso(dates[0]) : null
}

export function firstSlotDateInMonth(slots, year, monthIndex) {
  const prefix = `${year}-${String(monthIndex + 1).padStart(2, '0')}-`
  const dates = slotDates(slots)
    .filter((date) => date.startsWith(prefix))
    .sort()
  return dates[0] ? parseIso(dates[0]) : null
}

// Month → week: the week that holds the first planned post in the visible month.
// An empty month opens on the 1st, which is that month's first week.
export function weekFocusDate(anchor, slots) {
  const year = anchor.getFullYear()
  const month = anchor.getMonth()
  return firstSlotDateInMonth(slots, year, month) ?? new Date(year, month, 1)
}

// First day the week view shows after month → week. A week that would begin in
// the previous month starts on the 1st instead, so the view opens on this month.
export function monthWeekStart(focus, locale) {
  const aligned = startOfWeek(focus, locale)
  const monthStart = new Date(focus.getFullYear(), focus.getMonth(), 1)
  return aligned < monthStart ? monthStart : aligned
}
